import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzatzn7ffq: FaireProductEntity = {
  token: "p_bzatzn7ffq",
  type: "product",
  name: "Ceramic Vase, Tomato Can",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/a60c1817eb4b12c9409457eb6b82739cd9a47312fb6af48a6f4a2e31c0ebc141.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8df57c6c29a7138e0b4aedc46a4f73ff5971bd20e2d936d8b7d28c0d97e536ae.jpeg",
    "https://cdn.faire.com/fastly/eede2686518929451816bbab217abe902e943c1853cb678c89ef59e1cecdb623.jpeg",
    "https://cdn.faire.com/fastly/4345112fa99aba476a04aa1e815c34b2604ab6bbc5cdb931b1420c6fac3bac70.jpeg"
  ],
  priceDollars: 14.5,
  description: "Ah, yes, we’ll just help ourselves to this can of tomatoes—wait a second! That’s a vase! Designed to look like a classic can, this Bando ceramic vase is a playful twist on kitchen décor. Add a little bouquet (or a big one!) and let it instantly brighten your table, counter, or windowsill.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Ceramic vase designed to look like a vintage tomato can\n• Perfect for flowers, utensils, or as a standalone décor piece\n• Adds a playful pop of color to any kitchen or dining area\n• Durable and easy to clean\n• Designed in Bando’s signature quirky and cheerful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and home décor boutiques\n• Kitchenware and lifestyle retailers\n• Home décor lovers, hosts, and collectors\n• Wholesale buyers seeking fun, statement home accessories",
  tags: [],
  msrpDollars: 29.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:18.887Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
